import { Component, Inject, OnInit, DOCUMENT, ChangeDetectionStrategy } from '@angular/core';
import { I18nService } from '@digilize/shared/feature/modules/i18n/src';
import { getDefaultGitVersion } from '@digilize/shared/utils/helpers/src';

@Component({
  selector: 'suc-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class AppComponent implements OnInit {
  constructor(
    private i18nService: I18nService,
    @Inject(DOCUMENT) private document: Document
  ) {}

  ngOnInit(): void {
    this.i18nService.init();

    const { tag, hash } = getDefaultGitVersion();
    console.info('version:' + (tag ? tag : hash));
  }
}
